import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    countContents: idSource =>
      `${baseURL}/api/sources/${idSource}/contents/count`,
    getListOfContents: (idSource, params) =>
      `${baseURL}/api/sources/${idSource}/contents?${encodeParams(params)}`,
    addContentsSelection: (idSource, params) =>
      `${baseURL}/api/sources/${idSource}/contentsselection?${encodeParams(
        params
      )}`
  }
})(process.env.CONTENTS_PROVIDER_URL)

/**
 * @description Return the count of all available contents for the specified source id
 * @param {number} idSource ID of source
 * @returns {number} Get the contents count for the specified idSource
 *
 */
export const contentsProviderCountContents = idSource => {
  return apiWrapper({
    method: 'get',
    url: endpoints.countContents(idSource)
  }).then(extractApiData)
}

/**
 * @description Get the contents of source idSource
 * @param {number} idSource ID of source to update
 * @param {Object} params
 * @param {number} params.pageSize
 * @param {number} params.pageNumber
 * @param {('ContentKey'|'Image'|'Author'|'LinkURL'|'LinkText'|'Title'|'Summary'|'Category'|'CustomFieldName'|'CustomFieldValue')} params.searchBy Search by specified field as 'ContentKey’, 'Image’, 'Author’, 'LinkURL’, 'LinkText’, 'Title’, 'Summary’, 'Category’, 'CustomFieldName’, ‘CustomFieldValue’
 * @param {string} params.searchText Text to be searched
 * @param {('ContentKey'|'ContentLoadingDate'|'ContentDate'|'Title')} params.orderBy Order by specified field as 'ContentKey’, 'ContentLoadingDate’, 'ContentDate’, ‘Title’
 * @param {boolean} params.orderDescending order descending
 *
 */
export const contentsProviderGetListOfContents = (idSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfContents(idSource, params)
  }).then(extractApiData)
}

/**
 * @description Store few contents of sources idSource
 * @param {number} idSource ID of source to add
 * @param {Object} params
 * @param {number} params.timeToLive time to live in seconds
 * @param {Array<string>} params.contentsKey Contents key array that needs to be added to the store
 * @returns {string} Guid of the object created
 *
 */
export const contentsProvderAddContentsSelection = (idSource, params) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.addContentsSelection(idSource, params)
  }).then(extractApiData)
}
